<!-- <div style="display: flex; position: relative;"> -->
<mat-select
  #matSelect
  (click)="clickEvent()"
  (openedChange)="openedChange($event)"
  placeholder="{{ !isMultiSelect ? 'Select' : 'All' }}"
  [formControl]="selectFormControl"
  multiple
>
  <!-- <mat-select-trigger>
        {{selectFormControl.value ? selectFormControl.value[0] : ''}}
        <span *ngIf="selectFormControl.value?.length > 1" class="additional-selection">
            (+{{selectFormControl.value.length - 1}} {{selectFormControl.value?.length === 2 ? 'other' : 'others'}})
        </span>
    </mat-select-trigger> -->
  <div class="select-container">
    <mat-optgroup>
      <!--
        $event.stopPropagation() is there just to prevent space key and others to have
        any effect on mat options. Since default functionality of space key is to select 
        highlighted option.
      -->
      <input
        #search
        autocomplete="off"
        placeholder="Search"
        aria-label="Search"
        matInput
        [formControl]="searchTextboxControl"
        tabindex="-1"
        (keydown)="$event.stopPropagation()"
      />
      <button
        [disableRipple]="true"
        *ngIf="search.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="clearSearch($event)"
      >
        <mat-icon>close</mat-icon>
      </button>
      <button *ngIf="isMultiSelect" class="btn selectAll" (click)="selectAll()">
        Select All
      </button>
      <button
        *ngIf="isMultiSelect"
        class="btn selectAll"
        (click)="unSelectAll()"
      >
        Remove All
      </button>
    </mat-optgroup>
    <mat-optgroup *ngIf="dataToShow.length == 0">
      <div>No results found!</div>
    </mat-optgroup>
    <mat-option *ngFor="let option of dataToShow"
      (onSelectionChange)="selectionChange($event)"
      [value]="option[dataValueKey] || option"
    >
      {{ option[dataSearchKey] || option }}
    </mat-option>
  </div>
</mat-select>
<div *ngIf="toolTipType=='items' && bottomToolTip.total.length > 0" [ngClass]="{'fully-open': showAllToolTip}" class="bottom-tooltip">
  <div *ngIf="bottomToolTip.total.length > 4" class="selected-item show-more-btn" (click)="showAllToolTip=!showAllToolTip">
      <span>{{showAllToolTip ? '-':'+'}}{{(bottomToolTip.total | slice:4).length}}</span>
  </div>
  <div class="selected-items-container">
      <ng-container *ngFor="let item of bottomToolTip.items">
          <div class="selected-item">
              <span>{{item[dataSearchKey]}}</span>
              <button (click)="selectionChange({isUserInput: true, source: {selected:false, value: item[dataValueKey]}})" type="button">
                  <svg fill="#000000" width="12px" height="12px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 14.545L1.455 16 8 9.455 14.545 16 16 14.545 9.455 8 16 1.455 14.545 0 8 6.545 1.455 0 0 1.455 6.545 8z" fill-rule="evenodd"/>
                  </svg>
              </button>
          </div>
      </ng-container>
  </div>
</div>
<app-tooltip *ngIf="!toolTipType || toolTipType != 'items'" [data]="toolTipData"></app-tooltip>